module.exports = __webpack_public_path__ + "Thorn faceset.png?1076e406a9233a30cacbfd6718f0de8f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Thorn faceset.png
// module id = 114
// module chunks = 0